// src/helpers/factories/menu/cardFactories/menuTypes/menuTypeAssignedCategoriesFactory.ts
var menuTypeAssignedCategoriesFactoryCore = (menuTypeCategoryAssociationIds, categories) => menuTypeCategoryAssociationIds.map((menuTypeCategoryAssociationId) => {
  const category = categories[menuTypeCategoryAssociationId];
  const status = category.active;
  return {
    id: category.id,
    title: category.name,
    status,
    isStatusActive: status
  };
});

export { menuTypeAssignedCategoriesFactoryCore };
